import { IAppState } from '../../redux';
import { selectIsAuctionEnabled } from '../auction';
import { selectIsCalltrackingEnabled } from '../calltracking';

export const selectActiveAdditionalIds = (state: IAppState): Array<string> => {
  const isAuctionEnabled = selectIsAuctionEnabled(state);
  const isCalltrackingEnabled = selectIsCalltrackingEnabled(state);

  let services = [];

  if (isAuctionEnabled) {
    services.push('auction');
  }

  if (isCalltrackingEnabled) {
    services.push('calltracking');
  }

  return services;
};
